import EXP from '../assets/img/exp-logo-white.png';

const Marquee = () => {
  return (
    <div className="marquee">
    <section className="track">
      <article>
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
      </article>
      <article>
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
      </article>
      <article>
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
        <img src={EXP} alt="" />
      </article>
    </section>
    </div>
  );
}

export default Marquee;
